import { EnumTypeValue } from "@/shared/types";

export const SuggestieStatus = {
    NIEUW: "Nieuw",
    GENEGEERD: "Genegeerd",
    VOLDAAN: "Voldaan",
    UITGESTELD: "Uitgesteld",
} as const;
export type SuggestieStatus = EnumTypeValue<typeof SuggestieStatus>;

export const SUGGESTIES_QUERY_KEY = "suggesties";
